import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

async function getEntetes() {
  try {
    const res = await axiosInstance.get(baseUrl + '/facturation/entete');
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function getFactures(req) {
  try {
    const res = await axiosInstance.get(baseUrl + '/facturation/entete', {
      params: req,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function getDetailsFactures(req) {
  try {
    const res = await axiosInstance.post(baseUrl + '/facturation/detailsFactures', {
      params: req,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function getLignes(req) {
  try {
    const res = await axiosInstance.get(baseUrl + '/facturation/lignes', {
      params: req,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function creerFacture(data) {
  try {
    const res = await axiosInstance.post(baseUrl + '/facturation/creerFacture', data);
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

async function getProduits() {
  try {
    const res = await axiosInstance.get(baseUrl + '/products/produits');
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

export default {
  getEntetes,
  getFactures,
  getDetailsFactures,
  creerFacture,
  getLignes,
  getProduits,
};
